export const endpoint = 'https://journal-api.adaptable.app/';
